import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { TabelaPrecoItemTipoPrecificacaoAbreviacaoPipe } from './tabela-preco-item-tipo-precificacao-abreviacao.pipe';
import { TabelaPrecoSituacaoFilterPipe } from './tabela-preco-situacao-filter.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        // Pipes
        TabelaPrecoItemTipoPrecificacaoAbreviacaoPipe,
        TabelaPrecoSituacaoFilterPipe,
    ],
    exports: [
        SharedModule,

        // Pipes
        TabelaPrecoItemTipoPrecificacaoAbreviacaoPipe,
        TabelaPrecoSituacaoFilterPipe
    ],
    providers: [
        // Pipes
        TabelaPrecoItemTipoPrecificacaoAbreviacaoPipe,
        TabelaPrecoSituacaoFilterPipe,
    ]
})
export class TabelaPrecoPipeModule { }
